import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// SERVICES
import { AuthGuard } from './guards/auth.guard';
import { ConfirmService } from './services/app-confirm/confirm.service';
import { RoutePartsService } from './services/route-parts.service';

import { FormlyModule } from '@ngx-formly/core';
import { FileUploadComponent } from '../form/components/file-upload/file-upload.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { RouterModule } from '@angular/router';
import { OrganizationGuard } from './guards/organization.guard';
import { PatientStatusGuard } from './guards/patient.status.guard';
import { SummaryStatusGuard } from './guards/summary.status.guard';
import { LoginGuard } from './guards/login-guard.service';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { LogoutGuard } from './guards/logout.guard';
import { MetabaseStatsComponent } from './components/metabase-stats/metabase-stats.component';
import { SharedMaterialModule } from './shared-material.module';
import { SharedComponentsModule } from './components/shared-components.module';
import { OrganizationListGuard } from './guards/organization-list.guard';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { CycleHasIncentiveGuard } from './guards/cycle-hasIncentive.guard';
import { SharedDirectivesModule } from './directives/shared.directives.module';
import { RedirectLoginGuard } from './guards/redirect-login.guard';
import { SharedImageCropDialogComponent } from './dialogs/shared-image-crop-dialog/shared-image-crop-dialog.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { OrganizationInternalGuard } from './guards/organization-internal.guard';
import { SharedImageViewerDialogComponent } from './dialogs/shared-image-viewer-dialog/shared-image-viewer-dialog.component';
import { MariaModule } from './maria/maria.module';

@NgModule({
  declarations: [
    MetabaseStatsComponent,
    FileUploadComponent,
    SharedImageCropDialogComponent,
    SharedImageViewerDialogComponent
  ],
  imports: [
    MariaModule,
    SharedDirectivesModule,
    SharedComponentsModule,
    SharedPipesModule,
    RouterModule,
    NgxFileDropModule,
    CommonModule,
    FormlyModule,
    SharedMaterialModule,
    ImageCropperComponent,
  ],
  providers: [
    OrganizationInternalGuard,
    RedirectLoginGuard,
    CycleHasIncentiveGuard,
    CanDeactivateGuard,
    OrganizationListGuard,
    LogoutGuard,
    RoutePartsService,
    AuthGuard,
    ConfirmService,
    LoginGuard,
    OrganizationGuard,
    PatientStatusGuard,
    SummaryStatusGuard
  ],
  exports: [
    MariaModule,
    SharedDirectivesModule,
    SharedComponentsModule,
    MetabaseStatsComponent,
    SharedPipesModule,
    FileUploadComponent,
    FormlyModule,
  ],
})
export class SharedModule {
}
